"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es7.string.pad-start");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var enumConst = _interopRequireWildcard(require("@/utils/enum"));
var store = _interopRequireWildcard(require("@/api/store"));
var _Food = _interopRequireDefault(require("./Food"));
var _Order = _interopRequireDefault(require("./Order"));
var _MenuFood = _interopRequireDefault(require("./MenuFood"));
var _MapStore = _interopRequireDefault(require("./MapStore"));
var _Account = _interopRequireDefault(require("./Account"));
var _vuex = require("vuex");
var _Request = _interopRequireDefault(require("./Request"));
var _validate = require("@/utils/validate");
var _RateTab = _interopRequireDefault(require("./RateTab"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Order: _Order.default,
    Food: _Food.default,
    MapStore: _MapStore.default,
    Account: _Account.default,
    Request: _Request.default,
    MenuFood: _MenuFood.default,
    RateTab: _RateTab.default
  },
  props: {
    dialogDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    tabName: function tabName(val) {
      switch (val) {
        case "info":
        case "food":
        case "menufood":
          this.dialogWidth = "1300px";
          break;
        case "account":
          this.dialogWidth = "500px";
          break;
        default:
          this.dialogWidth = "1300px";
          break;
      }
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])), (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  data: function data() {
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!value) {
        callback(new Error("Vui lòng nhập email"));
      } else if (!(0, _validate.validEmail)(value)) {
        callback(new Error("Email không hợp lệ"));
      } else {
        callback();
      }
    };
    return {
      dialogWidth: "1300px",
      tabName: "info",
      STORE_TYPE: enumConst.STORE_TYPE,
      BusinessTypeTrans: enumConst.BusinessTypeTrans,
      typeVehicles: [],
      dialogLoading: false,
      marker: {},
      tempData: {
        type: "",
        openTime: "",
        closeTime: "",
        lat: 0,
        long: 0
      },
      dialogStatus: "",
      dialogVisible: false,
      loadingButton: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      rules: {
        name: {
          required: true,
          message: "Vui lòng nhập tên",
          trigger: "submit"
        },
        address: {
          required: true,
          message: "Vui lòng nhập địa chỉ",
          trigger: "submit"
        },
        // type: {
        //   required: true,
        //   trigger: "submit",
        //   message: "Vui lòng chọn loại cửa hàng"
        // },
        openTime: {
          required: true,
          message: "Vui lòng chọn giờ mở cửa",
          trigger: "submit"
        },
        closeTime: {
          required: true,
          message: "Vui lòng chọn giờ đóng cửa",
          trigger: "submit"
        },
        areaId: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn khu vực"
        },
        contactEmail: {
          required: false,
          type: "email",
          trigger: "submit",
          message: "Email không hợp lệ"
        },
        businessType: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn hình thức kinh doanh"
        },
        taxCode: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập mã số thuế"
        },
        contactAddress: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập địa chỉ liên lạc"
        },
        businessLicenseImage: {
          required: true,
          trigger: "submit",
          message: "Vui lòng upload ảnh giấy ĐK kinh doanh"
        }
      },
      timeOptions: this.generateTimeOptions()
    };
  },
  methods: {
    generateTimeOptions: function generateTimeOptions() {
      var options = [];
      // Tạo các tùy chọn thời gian với bước 30 phút
      for (var hour = 0; hour <= 23; hour++) {
        for (var minute = 0; minute < 60; minute += 30) {
          var time = "".concat(String(hour).padStart(2, "0"), ":").concat(String(minute).padStart(2, "0"));
          options.push(time);
        }
      }
      options.push("23:59"); // Thêm tùy chọn 23:59
      return options;
    },
    setAddress: function setAddress(address) {
      this.tempData.address = address;
    },
    setMarker: function setMarker(marker) {
      this.tempData.lat = marker.lat;
      this.tempData.long = marker.lng;
    },
    handleUploadSuccess: function handleUploadSuccess(res, file) {
      this.dialogLoading = false;
      this.$set(this.tempData, "thumbnail", res.data.path);
    },
    handleUploadBannerSuccess: function handleUploadBannerSuccess(res, file) {
      this.dialogLoading = false;
      this.$set(this.tempData, "bannerUrl", res.data.path);
    },
    handleUploadBusinessLicenseSuccess: function handleUploadBusinessLicenseSuccess(res, file) {
      this.dialogLoading = false;
      this.$set(this.tempData, "businessLicenseImage", res.data.path);
    },
    beforeUpload: function beforeUpload(file) {
      this.dialogLoading = true;
      var isJPG = file.type.includes("image");
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.dialogLoading = false;
        this.$message.error("Chỉ chấp nhận ảnh từ 2MB trở xuống");
      }
      if (!isJPG) {
        this.dialogLoading = false;
        this.$message.error("Avatar picture must be image format!");
      }
      return isJPG && isLt2M;
    },
    editData: function editData() {
      var _this = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var data = {
            store: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.tempData), {}, {
              bannerUrl: _this.tempData.bannerUrl,
              thumbnail: _this.tempData.thumbnail
            }),
            areaId: _this.tempData.areaId
          };
          _this.loadingButton = true;
          store.update(_this.tempData.id, data).then(function (res) {
            if (res.status) {
              _this.$notify({
                type: "success",
                message: "Cập nhật cửa hàng thành công"
              });
              _this.dialogVisible = false;
              _this.$emit("update:success");
            }
          }).finally(function () {
            _this.loadingButton = false;
          });
        }
      });
    },
    handleEdit: function handleEdit(data) {
      var _this2 = this;
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
        _this2.tempData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
          areaId: data.area && data.area.id
        });
        _this2.marker = {
          lat: data.lat,
          lng: data.long
        };
      });
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.dialogVisible = true;
      this.dialogStatus = "add";
      this.tabName = "info";
      this.$nextTick(function () {
        _this3.$refs["dataForm"].resetFields();
        _this3.marker = {};
        _this3.tempData = {
          type: "",
          openTime: "",
          closeTime: "",
          lat: 0,
          long: 0
        };
        if (_this3.$store.state.user.info.area) {
          _this3.$set(_this3.tempData, "areaId", _this3.$store.state.user.info.area.id);
        }
      });
    },
    createData: function createData() {
      var _this4 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var data = {
            store: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this4.tempData), {}, {
              bannerUrl: _this4.tempData.bannerUrl,
              thumbnail: _this4.tempData.thumbnail
            }),
            areaId: _this4.tempData.areaId
          };
          _this4.loadingButton = true;
          store.create(data).then(function (res) {
            if (res.status) {
              _this4.$notify({
                type: "success",
                message: "Tạo cửa hàng thành công"
              });
              _this4.dialogVisible = false;
              _this4.$refs["dataForm"].clearValidate();
              _this4.$emit("create:success");
            }
          }).finally(function () {
            _this4.loadingButton = false;
          });
        }
      });
    }
  }
};